import { DaylightCommonContent } from "../DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="daylight-work-surface relative isolate grid min-w-0 overflow-hidden rounded-[28px] p-4 before:absolute before:-bottom-32 before:-left-24 before:size-80 before:rounded-full before:bg-melon md:min-h-[43rem] md:grid-cols-[5fr_7fr] md:p-6">
    <DaylightMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="relative z-10 h-full min-h-80 min-w-0 w-full rounded-[22px] md:order-2"
      imageClassName="h-full object-cover transition-transform duration-400 ease-out hover:scale-[1.012]"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <DaylightCommonContent
      alignment={alignment}
      buttons={buttons}
      className="relative z-10 min-w-0 justify-end px-3 py-9 md:order-1 md:px-8 md:py-12 lg:px-12 lg:py-14"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="max-w-[10ch] text-[clamp(3rem,7vw,5.125rem)] leading-[0.98]"
      tone="light"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
